// extracted by mini-css-extract-plugin
export default {"preview":"BombBombPanelVideo_preview__B9uMO","recorder":"BombBombPanelVideo_recorder__vj5Cu","errorPreview":"BombBombPanelVideo_errorPreview__ptR8G"};